import { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete from 'react-places-autocomplete';
import { StyledInput } from './BaseInput';
import { useField, useFormikContext } from 'formik';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

const BaseGoogleAutocomplete = ({
  searchOptions,
  name,
  setLoaderGoogle,
  setAddressObj,
  errGoogle,
  setErrGoogle,
  ...otherProps
}) => {
  const [, setCoordinates] = useState({
    lat: null,
    lng: null,
  });

  const [field, meta] = useField(name);
  const { setFieldValue, submitForm } = useFormikContext();
  //   console.log('FIELD :', field);
  //   console.log('META : ', meta);

  const onChange = useCallback(
    (address) => {
      setFieldValue(name, address);
    },
    [name, setFieldValue]
  );

  const onError = useCallback(
    (status, clearSuggestions) => {
      setErrGoogle("Hmm… that Address doesn't look valid");
      clearSuggestions();
    },
    [setErrGoogle]
  );

  const onSelect = useCallback(
    async (value) => {
      setFieldValue(name, value);
      setLoaderGoogle(true);
      setErrGoogle('');

      const results = await geocodeByAddress(value);
      let storableLocation = {};

      for (let ac = 0; ac < results[0].address_components.length; ac++) {
        let component = results[0].address_components[ac];
        if (
          component.types.includes('sublocality') ||
          component.types.includes('locality')
        ) {
          storableLocation.city = component.long_name;
        } else if (component.types.includes('administrative_area_level_1')) {
          storableLocation.state = component.long_name;
        } else if (component.types.includes('postal_code')) {
          storableLocation.zip = component.long_name;
        } else if (component.types.includes('street_number')) {
          storableLocation.street1 =
            component.long_name === undefined ? '' : component.long_name;
        } else if (component.types.includes('route')) {
          storableLocation.street1 !== undefined
            ? (storableLocation.street1 += ' ' + component.long_name)
            : (storableLocation.street1 = component.long_name);
        } else if (component.types.includes('neighborhood')) {
          storableLocation.street2 = component.long_name;
        }
      }
      const latLng = await getLatLng(results[0]);
      setAddressObj({ ...storableLocation, full: value });
      setCoordinates(latLng);
      setLoaderGoogle(false);
    },
    [name, setFieldValue, setLoaderGoogle, setAddressObj, setErrGoogle]
  );

  return (
    <>
      <PlacesAutocomplete
        value={field.value}
        onChange={onChange}
        onSelect={onSelect}
        searchOptions={searchOptions}
        onError={onError}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <StyledInput
              {...getInputProps({
                placeholder: 'Type your answer here...',
                autoFocus: window.innerWidth > 768 ? true : false,
              })}
              onKeyDown={async (e) => {
                if (e.keyCode === 13) {
                  await submitForm();
                }
              }}
              name={name}
              {...otherProps}
            />
            <div>
              {loading ? <div> ...Loading</div> : null}

              {suggestions.map((suggestion, index) => {
                const style = {
                  backgroundColor: suggestion.active ? '#41b6e6' : '#fff',
                };
                return (
                  <div
                    key={index}
                    {...getSuggestionItemProps(suggestion, {
                      style,
                    })}
                  >
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
            {errGoogle && (
              <p style={{ marginTop: '15px', color: 'red' }}>{errGoogle}</p>
            )}
            {meta && meta.error && meta.touched && (
              <p style={{ marginTop: '15px', color: 'red' }}>{meta.error}</p>
            )}
          </div>
        )}
      </PlacesAutocomplete>
    </>
  );
};

BaseGoogleAutocomplete.propTypes = {
  searchOptions: PropTypes.object.isRequired,
  setLoaderGoogle: PropTypes.func.isRequired,
  addressObj: PropTypes.object,
  setAddressObj: PropTypes.func.isRequired,
  errGoogle: PropTypes.string,
  setErrGoogle: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default memo(BaseGoogleAutocomplete);
